import accidents from './accidents';
import vehiclesManagement from './vehicles-management';
import { VehicleInvoice } from '../CRUDs/entities/VehicleInvoice';



export default {
    dropzoneFiles: {},
    init() {
        this.testDropzone = vehiclesManagement.testDropzone,
        accidents.sort_date('invoices__table-box-img');
        this.inputCost('input-cost');
        this.initNewDropZone();
        this.listeners();
        
    },

    listeners(){
        $('body').off('click', '.data-view.vehicle-invoices .data-row .edit')
                .on('click', '.data-view.vehicle-invoices .data-row .edit', ev=>{
            new VehicleInvoice($(ev.currentTarget).data('invoice_id')).openModal('edit',{},false);
            vehiclesManagement.mytag('repairs_add');
        })
    },

    inputCost(id ='') {
        if (id == '') return false;
        $('.' + id).keydown(function(e){
            if ( event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 110 || event.keyCode == 190 ||
                (event.keyCode == 65 && event.ctrlKey === true) ||
                (event.keyCode >= 35 && event.keyCode <= 39)) {
                return;
            } else {
                if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105 )) {
                    event.preventDefault();
                }
            }
        });
    },

    initNewDropZone(){
        if(window.location.pathname.startsWith('/vehicles-management')){
            this.id = '';
            this.urlRoot = '/vehicles-mangement/';
            this.invoice =  new VehicleInvoice('', '/vehicles-management/vehicleInvoice', 'vehicle-invoice');
        }
    }
}
